import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkArchiveDocumentWorkflowTemplates } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { BulkArchiveDocumentWorkflowTemplatesDto } from '@dealstack/shared/lib/generated';
import { useMasterDocumentsEndpoints } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/useMasterDocumentsEndpoints.ts';

export const useBulkArchiveMasterDocuments = (onSuccess: () => void) => {
	const tMipManage = useTranslationMipManage();
	const queryClient = useQueryClient();
	const { list: listKey, bulkArchive } = useMasterDocumentsEndpoints();

	const mutationFn = (params: BulkArchiveDocumentWorkflowTemplatesDto) =>
		bulkArchiveDocumentWorkflowTemplates(bulkArchive, params);

	return useMutation({
		mutationFn: async (params: BulkArchiveDocumentWorkflowTemplatesDto) => {
			return await mutationFn(params);
		},
		onSuccess: async (result, variables) => {
			await queryClient.invalidateQueries({ queryKey: [listKey] });
			onSuccess?.();
			showToastV2({
				title: tMipManage(
					variables.archived
						? 'master_documents.toast.bulk_archive'
						: 'master_documents.toast.bulk_unarchive',
					{ count: result.count }
				),
			});
		},
		onError: () => {
			showToastV2({
				state: 'error',
				title: tMipManage('master_documents.toast.bulk_operation_error'),
			});
		},
	});
};
